module.exports = __webpack_public_path__ + "static/media/infoJumbo1.ab4ae686.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/exeron/images/infoJumbo1.jpg
// module id = 503
// module chunks = 0